import React from 'react';
export function Footer() {
  return <footer className="bg-[#050505] text-[#555] text-center py-8 px-6 text-[12px] leading-[2]" data-id="element-164">
      <p className="font-display text-[14px] text-white/30 mb-2 tracking-[1px] uppercase" data-id="element-165">
        🌿 MEGAPACK CUERPO NUEVO DESPUÉS DE LOS 40™
      </p>
      <p data-id="element-166">
        El sistema de alimentación metabólica N°1 para mujeres que quieren
        adelgazar,
        <br data-id="element-167" />
        desinflamarse y recuperar su energía en la menopausia.
      </p>
      <p className="mt-2.5" data-id="element-168">
        <a href="mailto:soporte@impulsodigitalstore.com" className="text-[#666] hover:text-brand-green transition-colors" data-id="element-169">
          soporte@impulsodigitalstore.com
        </a>
        &nbsp;·&nbsp;
        <a href="#" className="text-[#666] hover:text-brand-green transition-colors" data-id="element-170">
          @impulsodigital.store
        </a>
        &nbsp;·&nbsp;
        <a href="https://www.impulsodigitalstore.com" className="text-[#666] hover:text-brand-green transition-colors" data-id="element-171">
          www.impulsodigitalstore.com
        </a>
      </p>
      <p className="mt-2.5" data-id="element-172">
        <a href="#" className="text-[#666] hover:text-brand-green transition-colors" data-id="element-173">
          Términos y condiciones
        </a>{' '}
        ·{' '}
        <a href="#" className="text-[#666] hover:text-brand-green transition-colors" data-id="element-174">
          Política de privacidad
        </a>
      </p>
      <p className="mt-2.5" data-id="element-175">
        © 2026 MegaPack Cuerpo Nuevo después de los 40™ — Todos los derechos
        reservados.
        <br data-id="element-176" />
        Este producto es digital. No se envía ningún producto físico por correo.
      </p>
      <p className="mt-2 italic" data-id="element-177">
        Este sitio no forma parte de Facebook ni de Facebook Inc.
      </p>
    </footer>;
}